export default "__VITE_ASSET__DBPIN2DT__"